// One-shot "start listening on arrival" intent for Conversation mode.
//
// The entry control arms it as its form submits, for one destination — the
// path of that respondent's Conversation-mode sessions, which is the form's
// own action; the session page the server redirects to lives under it. The
// session page consumes it once on connect and starts the microphone without
// a further tap, but only when it is that destination: if the entry POST
// failed or landed elsewhere, a different conversation opened in the same tab
// must not inherit the intent. Arriving any other way — a bookmark, a review
// link, a refresh, history — leaves the microphone off until staff tap. It
// lives in sessionStorage so it survives the POST → redirect → full-page
// visit in the same tab and nothing else, and it expires so a stale arming
// cannot start a recording later.
const KEY = "voice_intake.start_intent"
const MAX_AGE_MS = 60_000

export function armStartIntent(destinationPath: string, now = Date.now()): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ path: destinationPath, at: now }))
  } catch {
    // Storage unavailable (private mode, quota): staff tap to start instead.
  }
}

// Consumes the intent (it is cleared whether or not it applies) and reports
// whether it was armed for +currentPath+: the destination itself or a page
// under it.
export function consumeStartIntent(currentPath: string, now = Date.now()): boolean {
  try {
    const raw = window.sessionStorage.getItem(KEY)
    if (raw === null) return false
    window.sessionStorage.removeItem(KEY)
    const armed = JSON.parse(raw) as { path?: unknown; at?: unknown }
    const path = typeof armed.path === "string" ? armed.path : ""
    const armedAt = Number(armed.at)
    if (path === "" || !Number.isFinite(armedAt) || now - armedAt < 0 || now - armedAt > MAX_AGE_MS) return false
    return currentPath === path || currentPath.startsWith(path.endsWith("/") ? path : `${path}/`)
  } catch {
    return false
  }
}
